/* eslint-disable */

import * as ApolloReactComponents from '@apollo/client/react/components';
import * as React from 'react';
import * as Apollo from '@apollo/client';
import { DocumentNode } from 'graphql';
import * as Types from '@99designs/graph-utils/types';

export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type RemoveStructuredBriefDesignersMutationVariables = Types.Exact<{
    id: Types.Scalars['String'];
    designerIds: Array<Types.Scalars['Int']> | Types.Scalars['Int'];
}>;

export type RemoveStructuredBriefDesignersMutation = {
    __typename: 'Mutation';
    removeStructuredBriefDesigners: {
        __typename: 'StructuredBrief';
        id: string;
        designers: Array<{ __typename: 'User'; id: string }>;
        designersWithSource: Array<{
            __typename: 'DesignerWithSource';
            source: Types.DesignerSource;
        }>;
    };
};

export const RemoveStructuredBriefDesignersDocument: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'RemoveStructuredBriefDesigners' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'designerIds' } },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'ListType',
                            type: {
                                kind: 'NonNullType',
                                type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                            },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'removeStructuredBriefDesigners' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'designerIds' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'designerIds' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'designers' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'designersWithSource' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'source' },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export type RemoveStructuredBriefDesignersMutationFn = Apollo.MutationFunction<
    RemoveStructuredBriefDesignersMutation,
    RemoveStructuredBriefDesignersMutationVariables
>;
export type RemoveStructuredBriefDesignersComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<
        RemoveStructuredBriefDesignersMutation,
        RemoveStructuredBriefDesignersMutationVariables
    >,
    'mutation'
>;

export const RemoveStructuredBriefDesignersComponent = (
    props: RemoveStructuredBriefDesignersComponentProps
) => (
    <ApolloReactComponents.Mutation<
        RemoveStructuredBriefDesignersMutation,
        RemoveStructuredBriefDesignersMutationVariables
    >
        mutation={RemoveStructuredBriefDesignersDocument}
        {...props}
    />
);

/**
 * __useRemoveStructuredBriefDesignersMutation__
 *
 * To run a mutation, you first call `useRemoveStructuredBriefDesignersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveStructuredBriefDesignersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeStructuredBriefDesignersMutation, { data, loading, error }] = useRemoveStructuredBriefDesignersMutation({
 *   variables: {
 *      id: // value for 'id'
 *      designerIds: // value for 'designerIds'
 *   },
 * });
 */
export function useRemoveStructuredBriefDesignersMutation(
    baseOptions?: Apollo.MutationHookOptions<
        RemoveStructuredBriefDesignersMutation,
        RemoveStructuredBriefDesignersMutationVariables
    >
) {
    return Apollo.useMutation<
        RemoveStructuredBriefDesignersMutation,
        RemoveStructuredBriefDesignersMutationVariables
    >(RemoveStructuredBriefDesignersDocument, baseOptions);
}
export type RemoveStructuredBriefDesignersMutationHookResult = ReturnType<
    typeof useRemoveStructuredBriefDesignersMutation
>;
export type RemoveStructuredBriefDesignersMutationResult =
    Apollo.MutationResult<RemoveStructuredBriefDesignersMutation>;
export type RemoveStructuredBriefDesignersMutationOptions = Apollo.BaseMutationOptions<
    RemoveStructuredBriefDesignersMutation,
    RemoveStructuredBriefDesignersMutationVariables
>;
